/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MxConnectWidgetUrlResponse
 */
export interface MxConnectWidgetUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof MxConnectWidgetUrlResponse
     */
    url: string;
}

/**
 * Check if a given object implements the MxConnectWidgetUrlResponse interface.
 */
export function instanceOfMxConnectWidgetUrlResponse(value: object): value is MxConnectWidgetUrlResponse {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function MxConnectWidgetUrlResponseFromJSON(json: any): MxConnectWidgetUrlResponse {
    return MxConnectWidgetUrlResponseFromJSONTyped(json, false);
}

export function MxConnectWidgetUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MxConnectWidgetUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function MxConnectWidgetUrlResponseToJSON(json: any): MxConnectWidgetUrlResponse {
    return MxConnectWidgetUrlResponseToJSONTyped(json, false);
}

export function MxConnectWidgetUrlResponseToJSONTyped(value?: MxConnectWidgetUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

